import { useEffect } from 'react';

import { editorStyles } from '../../styles';

function StyleInjector() {
  useEffect(() => {
    const styles = document.createElement('style');
    styles.textContent = editorStyles;
    document.head.appendChild(styles);

    return () => {
      document.head.removeChild(styles);
    };
  }, []);

  return null;
}

export default StyleInjector;
